module.exports = __webpack_public_path__ + "static/media/ball_003_a.f8166eb9.png";